import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DASHBOARD_URL } from "../../api/AdminUrls";
import { get } from "../../services/smartApiService";


const DashboardCards = () => {
  const [tabData, setTabData] = useState<any>([]);
  const navigate = useNavigate();

  const loadTableData = () => {
    let URL = DASHBOARD_URL.GET_COUNT;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const cardData = [
    {
      icon: "fa-user-md",
      name: "Total Loco Pilots Assessed",
      key: "total_trainees_attended",
      colorClass: "dash-card-third",
      nav_link: "/admin/trainee-list",
    },
    {
      icon: "fa-users",
      name: "Average Score (%)",
      key: "average_score",
      colorClass: "dash-card-pink",
      nav_link: "/admin/sessions/completed",
    },
    {
      icon: "fa-star",
      name: "Average Feedback",
      key: "average_feedback",
      colorClass: "dash-card-fourth",
      nav_link: "/admin/ratings",
      height: "dash-card-hight-big",
    },
    {
      icon: "fa-users",
      name: "Completed Sessions",
      key: "completed_sessions",
      colorClass: "dash-card-first",
      nav_link: "/admin/sessions/completed",
    },
    {
      icon: "fa-users",
      name: "Upcoming Sessions",
      key: "planned_sessions",
      colorClass: "dash-card-second",
      nav_link: "/admin/sessions/planned",
    },
  ];

  const mergedCardData = cardData.map((card) => ({
    ...card,
    count: tabData[card.key] ?? 0,
  }));

  const navigate_url = (obj: any) => {
    if (obj.nav_link) {
      navigate(obj.nav_link);
    }
  };

  const renderCard = (card: any, index: number) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.2 }}
      onClick={() => navigate_url(card)}
      className={`dash-card ${card.colorClass} ${card.height ?? ""}`}
    >
      <div className="is-flex is-align-items-center">
        <span className="icon mx-2 is-size-4">
          <i className={`fa ${card.icon}`}></i>
        </span>
        <div className="mt-2">
          <div className="site-title is-size-6">{card.name}</div>
          <div className="has-text-centered">
            <p className="title has-text-white"> {card.key=="average_feedback"? <p> {card.count}/10 </p>:<>{card.count}</>}</p>
          </div>
        </div>
        <i className="fa fa-angle-double-right mt-6 is-size-6 smart-dash-card-arrow-icon"></i>
      </div>
    </motion.div>
  );

  return (
    <div className="dashboard-grid">
      <div className="card-box">{renderCard(mergedCardData[0], 0)}</div>
      <div className="card-box">{renderCard(mergedCardData[1], 1)}</div>
      <div className="card-box tall smart-center-dash-card">{renderCard(mergedCardData[2], 2)}</div>
      <div className="card-box">{renderCard(mergedCardData[3], 3)}</div>
      <div className="card-box">{renderCard(mergedCardData[4], 4)}</div>
    </div>
  );
};

export default DashboardCards;
